import { createContext } from 'react';

const DiscussionDispatchContext = createContext();

export default DiscussionDispatchContext;
